import { inject, InjectionToken, TransferState } from "@angular/core";
import { IS_SERVER_TOKEN } from "./is-server.token";
import { SITE_CONFIG_KEY } from "./site-config-key.token";

export const IS_SSR_MODE_TOKEN = new InjectionToken<boolean>('IS_SSR_MODE_TOKEN', {
  providedIn: 'root',
  factory: () => {
    const tState = inject(TransferState, { optional: true }) ?? null;
    const isServer = inject(IS_SERVER_TOKEN);
    return isServer || (tState?.hasKey(SITE_CONFIG_KEY) ?? false);
  }
});
